__turbopack_context__.v({
  "header": "Header-module-scss-module__U6T9MW__header",
  "logoImage": "Header-module-scss-module__U6T9MW__logoImage",
  "logoWrapper": "Header-module-scss-module__U6T9MW__logoWrapper",
});
